export function initProject() {

	var Page = Barba.BaseView.extend({

		namespace: 'single-project',

		onEnter: function() {

			//console.log('Init Project');

			this.DOM = {};
			this.DOM.details = this.container.querySelector('.project--details');
			this.DOM.brand = document.querySelector('header .brand');
			document.querySelector('body > header').classList.add('white');

			this.projectColor = this.container.dataset.color;
			TweenMax.set(this.container.querySelectorAll('.hero'), {backgroundColor:this.projectColor} );
			TweenMax.set(this.container.querySelectorAll('.project--results'), {backgroundColor:this.projectColor} );
			TweenMax.set(this.container.querySelectorAll('p a'), {color:this.projectColor} );

			const player = new Plyr('#player');
			this.DOM.playerContainer = this.container.querySelector('.player__container');
			player.on('ready', event => {
				//TweenMax.set(this.container.querySelector('.plyr__control--overlaid'), {background:projectColor} );
				//TweenMax.set(this.container.querySelectorAll('.plyr--full-ui input[type=range]'), {color:projectColor} );
			});

			player.on('play', event => {
				const instance = event.detail.plyr;
				this.DOM.playerContainer.classList.add('playing');

				if (window.innerWidth > 767) {
					TweenMax.to(window,1.2, {scrollTo:{y:this.DOM.playerContainer.offsetTop, autoKill:false}, ease:Power3.easeOut});
					TweenMax.to(this.DOM.playerContainer, 0.4, {height:instance.elements.container.offsetHeight, ease:Power3.easeOut});
				}

			});

			player.on('pause', event => {
				const instance = event.detail.plyr;
				this.DOM.playerContainer.classList.remove('playing');
				TweenMax.to(this.DOM.playerContainer, 0.4, {height:"35vw", ease:Power3.easeOut});
			});

			this.DOM.projects = this.container.querySelectorAll('.project--preview');
			var mouseEnter = (e) => { e.currentTarget.querySelector('.video--cover').play(); }
			var mouseLeave = (e) => { e.currentTarget.querySelector('.video--cover').pause(); }
			
			this.DOM.projects.forEach((item) => {
				
				item.querySelector('.video--cover').currentTime = 2;
				
				item.addEventListener('mouseenter', mouseEnter);
				item.addEventListener('touchstart', mouseEnter);
				
				item.addEventListener('mouseleave', mouseLeave);
				item.addEventListener('touchend', mouseLeave);
			});
			
			window.addEventListener('scroll', this.onPageScroll);

		},

		onLeave: function() {

			document.querySelector('body > header').classList.remove('white');
			window.removeEventListener('scroll', this.onPageScroll);

		}

	});
	
	Page.onPageScroll = (e) => {
		Page.pageSy = window.pageYOffset || document.documentElement.scrollTop;
		if(Page.pageSy > (Page.DOM.details.offsetTop - Page.DOM.brand.offsetTop) && Page.pageSy < (Page.DOM.details.offsetTop + Page.DOM.details.offsetHeight - Page.DOM.brand.offsetTop)) {
			if (document.querySelector('body > header').classList.contains('white')) document.querySelector('body > header').classList.remove('white');
		} else {
			if (!document.querySelector('body > header').classList.contains('white')) document.querySelector('body > header').classList.add('white');
		}
	}

	Page.init();

}
